import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "Nome",
    key: "courseType",
    dataIndex: "title",
    ellipsis: true,
    width: 150,
  },
  {
    key: "yearsDuration",
    dataIndex: "yearsDuration",
    title: "Tipo attestato",
    ellipsis: true,
    width: 100,
    render: (years) => `${years} ann${years < 2 ? "o" : "i"}`,
  },
];

export default function () {
  return <SimpleTablePage title={"Categorie corsi"} resource="courseType" columns={columns} />;
}
